/**
 * valueをキーにしたオブジェクトを生成します。
 */
export const defineConstants = <T extends { readonly value: string }>(
  constants: readonly T[]
): {
  readonly [Value in T["value"]]: Extract<T, { readonly value: Value }>
} => {
  const obj = {} as any
  for (const constant of constants) {
    obj[constant.value] = constant
  }
  return obj
}
